var _circle, _path, _path2, _path3, _mask, _path4, _path5, _path6, _path7, _mask2, _path8;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDarkNoSmsBundle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    fill: "#1C1C1E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.143 37.686a2 2 0 0 1 1.986 2.023l-.12 10.329-.006 11.337-8.25-5.125.147-.164-13.459-.018a1 1 0 0 1-.998-1v-16.52a1 1 0 0 1 1.007-1l19.693.138z",
    fill: "#D6F3F3",
    fillOpacity: 0.24
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.132 39.735v13.622a2.331 2.331 0 0 0 0 .35c.044.57.305 1.1.725 1.47.42.372.94.9 1.49.854l1.55.121s-1.085-.573-1.322-.704a2.059 2.059 0 0 1-.616-.523 2.18 2.18 0 0 1-.453-1.548V39.71h-.786a1.782 1.782 0 0 0-.208.008l-.38.017z",
    fill: "#2F2F30"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#85A2A6",
    d: "M60.384 37.813h2.706v22.5h-2.706z"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "0i4i7xf47a",
    maskUnits: "userSpaceOnUse",
    x: 36.003,
    y: 34.874,
    width: 31,
    height: 29,
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M36.003 34.874h31v29h-31z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.975 37.874a4 4 0 0 1 4 4V51.6l.028-.016-.048 7.395c-.005.781-.838 1.275-1.494.886l-6.398-3.794H43.391a4 4 0 0 1-4-4V38.874a1 1 0 0 1 1-1h18.584z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M58.975 37.874v3-3zm4 13.725 1.46 2.62-4.46 2.487V51.6h3zm.028-.016-1.461-2.62 4.495-2.506-.034 5.146-3-.02zm-.048 7.395-3-.02 3 .02zm-1.494.886 1.53-2.58-1.53 2.58zm-6.398-3.794v-3h.823l.708.42-1.53 2.58zM40.391 37.874v-3 3zm19.584 4a1 1 0 0 0-1-1v-6a7 7 0 0 1 7 7h-6zm0 9.725v-9.724h6v9.724h-6zm4.489 2.604-.028.016-2.922-5.24.028-.016 2.922 5.24zm-4.51 4.755.049-7.395 6 .04-.049 7.395-6-.04zm3.037-1.675c-1.479-.877-3.027.309-3.036 1.675l6 .04c-.02 2.93-3.233 5.101-6.024 3.446l3.06-5.16zm-6.397-3.793 6.397 3.793-3.06 5.161-6.398-3.793 3.06-5.161zm-13.203-.42h11.672v6H43.391v-6zm-1-1a1 1 0 0 0 1 1v6a7 7 0 0 1-7-7h6zm0-13.196V52.07h-6V38.874h6zm-2 2a2 2 0 0 0 2-2h-6a4 4 0 0 1 4-4v6zm18.584 0H40.39v-6h18.584v6z",
    fill: "#18C8C3",
    mask: "url(#0i4i7xf47a)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.125 27.932a2 2 0 0 0-1.987 2.02l.092 8.908-.103 10.578 4.972-2.756 15.154-.019a1 1 0 0 0 1-1l-.001-16.844a1 1 0 0 0-1.006-1l-18.12.113z",
    fill: "#575E5F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M51.285 28.047v15.396a2.443 2.443 0 0 1-.842 2.058 2.412 2.412 0 0 1-1.762.577l-1.617.172a2.36 2.36 0 0 0 1.6-.863 2.393 2.393 0 0 0 .526-1.75V43.6L49.188 28l1.414.02c.081-.002.162 0 .242.009l.441.018z",
    fill: "#85A2A6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m34.717 34.933 10.146-.063M34.717 39.698l10.146-.063",
    stroke: "#18C8C3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "aw1reyt06b",
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 25,
    width: 32,
    height: 29,
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M23 25h32v29H23z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.032 28a4 4 0 0 0-4 4v9.726L27 41.709l.05 7.436a1 1 0 0 0 1.497.866l6.608-3.815H47.26a4 4 0 0 0 4-4V29a1 1 0 0 0-1-1H31.032z"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27.032 32h-3 3zm0 9.726L25.6 44.362l4.43 2.406v-5.042h-3zM27 41.709l1.431-2.637-4.465-2.424.034 5.08 3-.02zm.05 7.436-3 .02 3-.02zm1.497.866-1.5-2.598 1.5 2.598zm6.608-3.815v-3h-.804l-.696.402 1.5 2.598zM30.032 32a1 1 0 0 1 1-1v-6a7 7 0 0 0-7 7h6zm0 9.726V32h-6v9.726h6zm-4.463 2.62.032.016 2.862-5.273-.032-.017-2.862 5.273zm4.48 4.78L30 41.687l-5.999.04.05 7.437 6-.04zm-3.002-1.713c1.357-.784 2.993.212 3.003 1.712l-6 .04c.02 3.037 3.314 4.992 5.997 3.444l-3-5.196zm6.608-3.815-6.608 3.815 3 5.196 6.608-3.815-3-5.196zm13.604-.402H35.155v6H47.26v-6zm1-1a1 1 0 0 1-1 1v6a7 7 0 0 0 7-7h-6zm0-13.196v13.196h6V29h-6zm2 2a2 2 0 0 1-2-2h6a4 4 0 0 0-4-4v6zm-19.227 0h19.227v-6H31.032v6z",
    fill: "#18C8C3",
    mask: "url(#aw1reyt06b)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkNoSmsBundle);
export default __webpack_public_path__ + "static/media/darkNoSMSBundle.45dcc33463880f4b3119327b086ab76c.svg";
export { ForwardRef as ReactComponent };